import React from "react";
import ProrateForm from "./prorateForm";

export const Prorate = ({translate, prorateOnclick,invoiceAmount}) =>{
    return (
      <div className='prorate'>
        <ProrateForm
          translate={translate}
          prorateOnclick={prorateOnclick}
          invoiceAmount={invoiceAmount}
        ></ProrateForm>
      </div>
    )
}